<template>
    <div class="container-fluid p-5">
        <center>
            <h4 class="card-title text-dark">{{msgTitle}}</h4>
            <img style="height: 75px; width: 75px; display: block; border-radius:100px; border:1.5px solid #000000;" class="mb-4" :src="'/images/'+ msgImg + '.svg'" :alt="msgTitle">
            <h6 class="card-subtitle mb-2 text-muted" style="margin-top:-12px; font-size:10pt;">{{msgDate}}</h6>
            <p class="card-text text-dark mt-3">"{{msgMsg}}"</p>
            <br/>
        </center>
    </div>
</template>
<style scoped>

</style>
<script>
export default {
    data:() => ({
        showEmbed: false,
    }),
    props:{
        msgTitle: {
            type: String,
            default: 'No Title Message'
        },
        msgImg:  {
            type: Number,
            default: 1
        },
        msgDate:  {
            type: String,
            default: 'No Message Date'
        },
        msgMsg:  {
            type: String,
            default: 'No Message'
        },
        msgNumb: {
            type: Number,
            default: 0
        }
    }
}
</script>

